<template>
    <el-dialog
        :title="(isForm ? (roleId ? '编辑' : '添加角色') : '查看') + dialogTitle"
        :close-on-click-modal="false"
        width="640px"
        :model-value="modelValue"
        @close="closed"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px" style="max-width: 540px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="角色名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name"></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="权限字符" prop="code">
                        <el-input v-if="isForm" v-model="formData.code"></el-input>
                        <span v-else>{{ formData.code }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="角色顺序">
                        <el-input-number
                            v-if="isForm"
                            v-model="formData.list_order"
                            class="mx-4"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                        />
                        <span v-else>{{ formData.list_order }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="状态">
                        <el-radio-group v-if="isForm" v-model="formData.status">
                            <el-radio :value="1">正常</el-radio>
                            <el-radio :value="0">停用</el-radio>
                        </el-radio-group>
                        <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="菜单权限">
                <div class="group" v-if="isForm">
                    <el-checkbox v-model="checked1" label="展开/折叠" size="large" />
                    <!-- <el-checkbox v-model="checked2" label="全选/全不全" size="large" /> -->
                    <el-checkbox v-model="checkStrictly" label="父子联动" size="large" />
                </div>
                <el-tabs v-model="currentModule" class="demo-tabs" @tab-click="handleClick" style="width: 100%">
                    <el-tab-pane
                        v-for="item in moduleOptionLists"
                        :label="item.name"
                        :name="item.id"
                        :key="item.id"
                    ></el-tab-pane>
                </el-tabs>
                <el-scrollbar v-if="isForm" style="height: 300px; overflow: auto; width: 100%">
                    <el-tree
                        ref="treeRef"
                        :data="allAuthsData"
                        show-checkbox
                        node-key="id"
                        :props="defaultProps"
                        :check-strictly="!checkStrictly"
                        @check="handleCheck"
                    ></el-tree>
                </el-scrollbar>
                <el-scrollbar v-else style="height: 300px; overflow: auto">
                    <el-tree
                        ref="userTreeRef"
                        :data="userAuthsData"
                        node-key="id"
                        default-expand-all
                        :props="defaultProps"
                    ></el-tree>
                </el-scrollbar>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-if="isForm" v-model="formData.remark" type="textarea"></el-input>
                <div v-else>{{ formData.remark }}</div>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, nextTick, ref, watch } from 'vue'
import { addRole, getRoleDetail, putRole } from '@/api/role'
import { getAuthTree } from '@/api/auth'
import { ElMessage } from 'element-plus'
import { getModuleOptionLists } from '@/api/module'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    roleId: {
        type: String,
        required: false
    }
})
const dialogTitle = ref('')

const emits = defineEmits(['update:modelValue', 'updateForm'])

const checked1 = ref(false)
const checked2 = ref(false)
const checkStrictly = ref(true)

// 表单源
const formData = ref({
    name: '',
    code: '',
    auth_check_strictly: 1,
    auths: [],
    part_auths: [],
    list_order: 1,
    status: 1,
    visible: 1,
    remark: ''
})
// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入角色名称'
        }
    ],
    code: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入权限字符'
        }
    ]
})

const submitLoading = ref(false)
const formRef = ref(null)
const treeRef = ref(null)
// el-tree属性结构配置
const defaultProps = {
    children: 'children',
    label: 'name'
}
// 获取所有权限
const allAuthsData = ref([])
const allAuthsDataId = ref([])
const dogetAuthTree = async (filter) => {
    allAuthsDataId.value = []
    const getAllId = (data) => {
        data.forEach((ele) => {
            allAuthsDataId.value.push(ele.id)
            if (ele.children) {
                getAllId(ele.children)
            }
        })
    }
    allAuthsData.value = await getAuthTree({ mod: currentModule.value })
    getAllId(allAuthsData.value)
    await nextTick()
    allAuthsData.value.forEach((auth) => {
        if (formData.value.auths.includes(auth.id)) {
            treeRef.value.setChecked(auth, true, false)
        }
        auth.children &&
            auth.children.forEach((ele) => {
                if (formData.value.auths.includes(ele.id)) {
                    treeRef.value.setChecked(ele, true, false)
                }
            })
    })
}

const userTreeRef = ref(null)
const userAuthsData = ref([])

// 关闭
const closed = () => {
    emits('update:modelValue', false)
    dialogTitle.value = ''
    formRef.value && formRef.value.resetFields()
    treeRef.value && treeRef.value.setCheckedKeys([], false)
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.roleId !== '') {
        await doPutRole()
    } else {
        await doAddRole()
    }
}

// 修改模块
const doPutRole = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await putRole(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 模块修改成功
        emits('updateForm')
        ElMessage.success('修改成功！')
        submitLoading.value = false
        closed()
    })
}

// 添加模块
const doAddRole = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await addRole(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 模块添加成功
        emits('updateForm')
        ElMessage.success('添加成功！')
        submitLoading.value = false
        closed()
    })
}

// 获取角色详情
const doGetRoleDetail = async () => {
    const data = await getRoleDetail(props.roleId)
    formData.value = {
        id: data.id,
        name: data.name,
        code: data.code,
        auth_check_strictly: data.auth_check_strictly,
        auths: data.auths,
        part_auths: data.part_auths,
        list_order: data.list_order,
        status: data.status,
        visible: data.visible,
        remark: data.remark
    }
    dialogTitle.value = name
    if (treeRef.value) {
        //
        setTimeout(() => {
            treeRef.value.setCheckedKeys(data.auths)
        }, 100)
    }
}

// 模块选项列表
const moduleOptionLists = ref([])
const currentModule = ref('')
// 获取数据的方法
const getModuleOptionListsData = async () => {
    const moduleOptionRes = await getModuleOptionLists({})
    moduleOptionLists.value = moduleOptionRes
    currentModule.value = moduleOptionRes[0].id
    await dogetAuthTree()
}
const handleClick = async (data) => {
    formData.value.auths = Array.from(new Set(formData.value.auths.concat(treeRef.value.getCheckedKeys())))
    formData.value.part_auths = Array.from(new Set(formData.value.part_auths.concat(treeRef.value.getHalfCheckedKeys())))
    currentModule.value = data.paneName
    await dogetAuthTree()
}

const handleCheck = (node, data) => {
    delCurrentAuth()
    formData.value.auths = formData.value.auths.concat(data.checkedKeys)
    formData.value.part_auths = formData.value.part_auths.concat(data.halfCheckedKeys)
}

const delCurrentAuth = () => {
    for (let i = 0; i < allAuthsDataId.value.length; i++) {
        const ele = allAuthsDataId.value[i]
        const checkedKeyIndex = formData.value.auths.findIndex((item) => item === ele)
        if (checkedKeyIndex > -1) {
            formData.value.auths.splice(checkedKeyIndex, 1)
        }
        const checkedHalfKeyIdex = formData.value.part_auths.findIndex((item) => item === ele)
        if (checkedHalfKeyIdex > -1) {
            formData.value.part_auths.splice(checkedHalfKeyIdex, 1)
        }
    }
}

// 只有roleId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal) {
            getModuleOptionListsData()
        }
        if (newVal && props.roleId) {
            doGetRoleDetail()
        } else {
            // 置空
            formData.value = {
                name: '',
                code: '',
                auth_check_strictly: 1,
                auths: [],
                part_auths: [],
                list_order: 1,
                status: 1,
                visible: 1,
                remark: ''
            }
        }
    }
)

watch(checked1, (newVal) => {
    const treeNode = treeRef.value.store.nodesMap
    for (const item in treeNode) {
        treeNode[item].expanded = newVal
    }
})

watch(checked2, (newVal) => {
    if (newVal) {
        const treeNode = treeRef.value.store.nodesMap
        treeRef.value.setCheckedKeys(Object.keys(treeNode))
    } else {
        treeRef.value.setCheckedKeys([])
    }
})
</script>

<style lang="scss" scoped></style>
